<script>
import Loader from '@/components/widgets/loader';
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  components: {
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    valueTitle: {
      type: [String, Number],
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    component: {
      type: Object,
      default: undefined
    },
    titleClass: {
      type: String,
      default: '',
    },
    valueClass: {
      type: String,
      default: 'mb-0 stat-value',
    },
  },
};
</script>

<template>
  <Loader :loading="loading">
    <div class="card mini-stats-wid border-0" style="padding: 12px; height: 89px">
      <div class="card-body p-0">
        <div class="">
          <div class="">
            <div :class="['stat-title', titleClass]">{{title}}</div>
            <div class="d-flex align-items-end gap-1">
              <div :class="valueClass" >{{value}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end card -->
  </Loader>
</template>


<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    right: 20px !important;
    background-color: rgba(255,255,255,0.5);
  }
  .status {
    left: 90%;
    right: 10%;
    .spinner-chase {
      width: 24px;
      height: 24px;
      margin: 8px;
    }
  }
}
.mini-stats-wid {
  .media-body {
    p {
      font-weight: 500;
      font-size: 14px;
      color: #6C7589 !important;
    }

    h4 {
      font-weight: 800;
      font-size: 18px;
      color: #161B4D;
    }
  }
}

.stat-title {
  font-weight: 500;
  font-size: 14px;
  color: #6C7589;
}

.stat-value {
  font-weight: 800;
  font-size: 36px;
  line-height: 43px;
  letter-spacing: 0.02em;
  color: #161B4D;
}
</style>